import { createSlice } from "@reduxjs/toolkit";

export const systemSettingSlice = createSlice({
  name: "systemSetting",
  initialState: {
    getSystemSettingResult: false,
    getSystemSettingLoading: false,
    getSystemSettingError: false,
    addSystemSettingResult: false,
    addSystemSettingLoading: false,
    deleteSystemSettingResult: false,
  },
  reducers: {
    systemSettingReducers: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "GET_SYSTEMSETTING":
          return {
            ...state,
            getSystemSettingResult: payload.data,
            getSystemSettingLoading: payload.loading,
            getSystemSettingError: payload.error,
          };
        case "ADD_SYSTEMSETTING":
          return {
            ...state,
            addSystemSettingResult: payload.data,
            addSystemSettingLoading: payload.loading,
          };
        case "DELETE_SYSTEMSETTING":
          return {
            ...state,
            deleteSystemSettingResult: payload.data,
          };
        default:
          return state;
      }
    },
  },
});

export const { systemSettingReducers } = systemSettingSlice.actions;

export default systemSettingSlice.reducer;
